module.exports = __webpack_public_path__ + "static/media/30.5f33da15.jpg";